module.exports = __webpack_public_path__ + "static/media/felipe.28838230.JPG";